import React from 'react'
import {Icon} from '@chakra-ui/react'

const ExclamationIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                d="M20.0878 33.8641C18.605 33.8641 17.4092 35.06 17.4092 36.5428C17.4092 38.0256 18.605 39.231 20.0878 39.231C21.5706 39.231 22.7664 38.0352 22.7664 36.5428C22.7664 35.0504 21.5706 33.8641 20.0878 33.8641Z"
                fill="currentColor"
            />
            <path
                clipRule="evenodd"
                d="M20.0886 0.86908L19.7156 0.888213C17.5631 1.10824 15.9942 2.86849 16.1951 4.90616L18.7876 31.0037C18.9407 32.5726 21.2271 32.5726 21.3801 31.0037L23.9822 4.90616C24.2023 2.71542 22.3655 0.878646 20.0886 0.878646V0.86908ZM21.8776 5.57582C21.6767 11.4688 20.0886 29.0808 20.0886 29.0808C20.0886 29.0808 18.4336 11.4688 18.1945 5.58539C18.1658 4.87746 18.1945 2.92589 20.0121 2.92589C21.8298 2.92589 21.9063 4.8679 21.8872 5.58539L21.8776 5.57582Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ExclamationIcon
